import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useChargesStore = defineStore('charges', () => {
  const fromDate = ref<string | undefined>(undefined);
  const toDate = ref<string | undefined>(undefined);
  const groupByRepresentative = ref(false);

  return { fromDate, toDate, groupByRepresentative };
}, { persist: true });
